import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";

/**
 * `UploadCommand` is the command used to upload a new file.
 * `UploadCommand` is always valid as I do not depend of the current
 * selection.
 */
export default class UploadCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._name = "";
	}

	name() {
		return this._name;
	}

	setName(newValue) {
		this._name = newValue;
	}

	accept(aVisitor) {
		return aVisitor.visitUploadCommand(this);
	}

	requireRefresh() {
		return true;
	}

	heading() {
		return getNamedCommandHeading("Folder");
	}

	priority() {
		return 10;
	}

	uploadPath() {
		return this._documentService.uploadPath();
	}

	_performOnService(callback) {
		this._documentService.executeUploadCommand(this, callback);
	}

	_execute() {
		// Creating folders is only supported on the server-side
		// as we need the ID provided by the server after the
		// folder creation
		// Todo: discuss it with Henrik
	}

	static isApplicable() {
		return true;
	}
}
